<ng-template #exitButton>
	<!-- Wizard verlassen -->
	<app-splitbutton class="back-button" *ngIf="!workflowItem.showOverview" [elements]="[cancelWorkflowSplitbutton]"></app-splitbutton>
	<!-- Zur Fragebogenübersicht -->
	<app-splitbutton class="back-button" *ngIf="workflowItem.showOverview" [elements]="[overviewWorkflowSplitbutton]"></app-splitbutton>
</ng-template>

<ng-container *ngIf="workflowItem">
	<div *ngIf="statusSet | async" class="content compact-view">
		<div class="toolbar">
			<ng-container [ngTemplateOutlet]="exitButton"></ng-container>
			<ng-container *ngIf="workflowItem?.config?.disableDetailPage">
				<app-splitbutton *appIfPermission="'workflow:item:delete'" [elements]="[resetWorkflowSplitbutton]"></app-splitbutton>
			</ng-container>
		</div>
		<form nz-form>
			<div *ngFor="let group of workflowItem.groups, let index = index" class="mb-3" [hidden]="hiddenStatus[index]">
				<div nz-row nzJustify="space-between" [nzGutter]="[16, 6]">
					<div nz-col class="gutter-row">
						<h1 [id]="'p_' + index">{{ group.title }}</h1>
					</div>
					<ng-container appWorkflowItemData>
						<workflow-missing-value-button [finishedAndLocked]="finishedAndLocked" [group]="group"
							[disabled]="!hasWorkflowWritePermission"></workflow-missing-value-button>
					</ng-container>
				</div>
				<div *ngIf="group.preface" nz-row [nzGutter]="[16, 6]">
					<div nz-col [nzSpan]="24" class="gutter-row">
						<div class="additional-info">
							<h3>{{ 'misc.hint' | translate }}</h3>
							<a class="info-toggle" (click)="togglePrologue(index)">
								<span *ngIf="!prologPage[index]">{{ 'actions.show' | translate}}</span>
								<span *ngIf="prologPage[index]">{{ 'actions.hide' | translate}}</span>
							</a>
						</div>
						<ng-container *ngIf="prologPage[index]">
							<div *ngFor="let preface of group.preface" markdown [data]="preface"></div>
						</ng-container>
					</div>
				</div>
				<div *ngIf="group?.items" nz-row [nzGutter]="[16, 6]">
					<div *ngFor="let question of group.items, let i = index" nz-col [nzSpan]="24" class="gutter-row">
						<nz-card class="question-card"
							[hidden]="questionHiddenStatus && questionHiddenStatus[index] && questionHiddenStatus[index][i]"
						>
							<nz-card-meta [nzTitle]="cardTitle"></nz-card-meta>
							<ng-template #cardTitle>
								<div nz-row nzJustify="space-between">
									<div nz-col class="gutter-row">
										<h3>{{ question.title }}</h3>
									</div>
								</div>
								<div *ngIf="questionStatus && questionStatus[index] && questionStatus[index][i]" nz-row class="offset-1">
									<h3>
										<i-feather class="icon" [ngClass]="questionStatus[index][i]" [name]="questionStatus[index][i]">
										</i-feather>
									</h3>
								</div>
							</ng-template>

							<div markdown *ngIf="question.description" [data]="question.description"></div>
							<ng-container [ngSwitch]="question.type">
								<workflow-questionnaire-block-question *ngSwitchCase="'BlockQuestion'" (valid)="updateInputValidity($event, i, index)"
									[group]="group" [hasWorkflowWritePermission]="hasWorkflowWritePermission"
									[blockMissingValueKey]="question.missingValueKey"
									[question]="question" [finishedAndLocked]="finishedAndLocked">
								</workflow-questionnaire-block-question>
								<workflow-special-question *ngSwitchCase="isSpecialQuestion(question) && question?.type"
									[hasWorkflowWritePermission]="hasWorkflowWritePermission"
									(valid)="updateInputValidity($event, 0, index)"
									[question]="question"
									[isWizard]="false"
									[finishedAndLocked]="finishedAndLocked"
									[groupMissingValueKey]="group.missingValueKey"
									[overviewConfigs]="group.groupOverview"
									[wizardLink]="wizardLink(index, i)">
								</workflow-special-question>
								<div *ngSwitchDefault>
									{{ question.type }}
								</div>
							</ng-container>

						</nz-card>
					</div>
				</div>
				<div *ngIf="group.epilog" nz-row [nzGutter]="[16, 6]">
					<div nz-col [nzSpan]="24" class="gutter-row">
						<div class="additional-info">
							<h3>{{ 'misc.hint' | translate }}</h3>
							<a class="info-toggle" (click)="toggleEpilog(index)">
								<span *ngIf="!epilogPage[index]">{{ 'actions.show' | translate}}</span>
								<span *ngIf="epilogPage[index]">{{ 'actions.hide' | translate}}</span>
							</a>
						</div>
						<ng-container *ngIf="epilogPage[index]">
							<div *ngFor="let preface of group.epilog" markdown [data]="preface"></div>
						</ng-container>
					</div>
				</div>
			</div>
		</form>
		<nz-alert *ngIf="unfinishedItems.items.length && !finishedAndLocked"
							nzType="warning" nzShowIcon
							nzMessage="{{ 'message.warning.not_finished_sufficient' | translate }}"
							[nzDescription]="unfinishedItemsTemplate"
		></nz-alert>
		<ng-template #unfinishedItemsTemplate>
			<ul>
				<!-- TODO GSP-190 - Ordentliche Hinweistexte -->
				<li *ngFor="let unfinishedText of unfinishedItems.items">{{ unfinishedText }}</li>
				<li *ngIf="unfinishedItems.additionalAmount">+{{ unfinishedItems.additionalAmount }}</li>
			</ul>
		</ng-template>
		<div class="toolbar bottom-buttons">
			<ng-container [ngTemplateOutlet]="exitButton"></ng-container>
			
			<app-badge-icon	[appWorkflowItemStatus]="workflowItem.id"></app-badge-icon>
			<!--Zurück zur Übersicht-->
			<app-splitbutton appEndWorkflowItem [disabled]="finishWorkflowSplitbutton.disabled"></app-splitbutton>
		</div>
	</div>
</ng-container>

<workflow-projektsidebar class="sidebar" *ngIf="participant" [currentParticipant]="participant">
</workflow-projektsidebar>

<ng-template appModal let-close #confirm="appModal">
	<nz-modal
		[nzMaskClosable]="false"
		nzVisible
		nzTitle="{{ 'workflow.modal.finish.title' | translate }}"
		(nzOnOk)="close(true)"
		(nzOnCancel)="close(false)"
		nzOkText="{{ confirmationModalConfig?.textOK || 'actions.OK' | translate }}"
		nzCancelText="{{ 'actions.cancel' | translate }}"
	>
		{{ confirmationModalConfig?.textMessage || 'workflow.modal.finish.text' | translate }}
	</nz-modal>
</ng-template>

<ng-template appModal let-close #confirmReset="appModal">
	<nz-modal
		[nzMaskClosable]="false"
		nzVisible
		nzTitle="{{ 'workflow.modal.reset.title' | translate }}"
		(nzOnOk)="close(true)"
		(nzOnCancel)="close(false)"
		nzOkText="{{'actions.OK' | translate }}"
		nzCancelText="{{ 'actions.cancel' | translate }}"
	>
		{{ 'workflow.modal.reset.text' | translate }}
	</nz-modal>
</ng-template>
